import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, useModal, usePanorama } from '@wix/yoshi-flow-editor';
import { Button, ButtonPriority } from '@wix/wix-ui-tpa';
import { classes } from './AddToCartButton.st.css';
import settingsParams from '../../../settingsParams';
import { useControllerProps } from '../../ControllerContext';
import { useState } from '../../stores';
import { SuccessIcon } from './SuccessIcon';
import { PanoramaTransactions } from '../../../../../consts';

export const AddToCartButtonDataHooks = {
  button: 'AddToCartButton.button',
};

const AddToCartButton = () => {
  const {
    state: { checkout: checkoutState },
  } = useState();

  const panorama = usePanorama();
  const settings = useSettings();
  const { isPreview } = useEnvironment();
  const { product, currencyCode } = useControllerProps().giftCardStore;
  const postAction = settings.get(settingsParams.addToCartPostAction);
  const { creatingCheckout, addingToCart } =
    useControllerProps().giftCardCheckoutStore;
  const { addToCart, reportCheckout } =
    useControllerProps().giftCardCheckoutStore;
  const { openModal: openPreviewBlockingModal } = useModal(
    'PreviewBlockingModal',
    {
      width: 520,
      height: 270,
      theme: 'BARE',
    },
  );
  const onAddToCartButtonClick = () => {
    if (product) {
      panorama.transaction(PanoramaTransactions.giftCardAddToCart).start();
      addToCart(
        product,
        checkoutState.purchaseOptions,
        currencyCode || '',
        postAction,
      );
      reportCheckout({
        product,
        purchase_options: checkoutState.purchaseOptions,
        currencyCode: currencyCode || '',
        type: 'add to cart',
      });
      panorama.transaction(PanoramaTransactions.giftCardAddToCart).finish();
    }
  };

  return (
    <>
      <Button
        data-hook={AddToCartButtonDataHooks.button}
        className={classes.button}
        fullWidth
        upgrade
        disabled={creatingCheckout || addingToCart}
        priority={ButtonPriority.primary}
        onClick={() => {
          if (isPreview) {
            openPreviewBlockingModal();
          } else if (product) {
            onAddToCartButtonClick();
          }
        }}
      >
        {addingToCart && postAction === 'stayOnPage' ? (
          <SuccessIcon />
        ) : (
          settings.get(settingsParams.addToCartButtonText)
        )}
      </Button>
    </>
  );
};

export default AddToCartButton;
